{
    "translation": {
        "welcome": "Benvenuto",
        "home": "Home",
        "find_pro": "Trova un Professionista",
        "admin": "Admin",
        "my_space": "Il Mio Spazio",
        "login": "Accedi",
        "logout": "Esci",
        "search_placeholder": "Parrucchiere, Barbiere, Manicure...",
        "hero_welcome": "Benvenuto su OpenGlow",
        "hero_slogan": "L'eccellenza a portata di mano.",
        "hero_desc": "Prenota i tuoi trattamenti di bellezza e benessere in pochi clic. Semplice, veloce ed elegante.",
        "hero_title": "Prenota il tuo appuntamento di bellezza",
        "hero_subtitle": "Trova i migliori professionisti vicino a te.",
        "search_btn": "Cerca",
        "popular_services": "Servizi Popolari",
        "footer_rights": "Tutti i diritti riservati.",
        "footer_about_us": "Chi siamo",
        "legal_mentions": "Note Legali",
        "cgp": "Condizioni Generali di Servizio",
        "feature_search_title": "Cerca",
        "feature_search_desc": "Trova i migliori saloni ed esperti vicino a te",
        "feature_book_title": "Prenota",
        "feature_book_desc": "Scegli il tuo orario ideale in pochi secondi",
        "feature_enjoy_title": "Goditi",
        "feature_enjoy_desc": "Vivi un'esperienza di bellezza unica e rilassante",
        "featured_pros_title": "Professionisti in Evidenza",
        "reviews_count": "recensioni",
        "client_space": "AREA CLIENTI",
        "my_bookings": "Le Mie Prenotazioni",
        "explore_map": "Esplora Mappa",
        "edit_photo": "Modifica Foto",
        "photo_updated": "Foto del profilo aggiornata!",
        "error_upload": "Errore durante il caricamento della foto.",
        "search_action": "Cerca",
        "filters_all": "Tutti",
        "filter_sort": "Filtri",
        "filter_distance_nearest": "Distanza: più vicino",
        "filter_rating_highest": "Valutazione: migliore",
        "filter_reviews_most": "Recensioni: più numerose",
        "filter_name_az": "Nome: A-Z",
        "filter_min_rating": "Valutazione minima",
        "filter_max_distance": "Distanza massima",
        "show_filters": "Mostra filtri",
        "hide_filters": "Nascondi filtri",
        "map_style": "Stile",
        "map_enable_location_filter": "Attiva la posizione per filtrare per distanza",
        "profession_hairdresser": "Parrucchiere",
        "profession_esthetician": "Estetista",
        "profession_barber": "Barbiere",
        "profession_manicure": "Manicure",
        "profession_masseur": "Massaggiatore",
        "settings_title": "Impostazioni",
        "settings_back": "Indietro",
        "settings_section_appearance": "Aspetto",
        "settings_theme_intro": "Scegli il tema dell'applicazione.",
        "settings_theme_classic": "Bianco & Nero",
        "settings_theme_ocean": "Oceano",
        "settings_theme_rose": "Rosa",
        "settings_theme_dark": "Scuro",
        "settings_theme_night": "Notte",
        "settings_compact_mode": "Modalità compatta",
        "settings_compact_mode_sub": "Riduce la spaziatura di questa pagina",
        "settings_section_notifications": "Notifiche",
        "settings_notif_email": "Email di prenotazione",
        "settings_notif_email_sub": "Conferme e promemoria degli appuntamenti",
        "settings_notif_push": "Centro notifiche",
        "settings_notif_push_sub": "Avvisi nell'applicazione",
        "settings_notif_marketing": "Novità & offerte",
        "settings_notif_marketing_sub": "Aggiornamenti prodotto e promozioni",
        "settings_section_account": "Account",
        "settings_account_profile": "Profilo",
        "settings_account_email_label": "Indirizzo email",
        "settings_not_connected": "Non connesso",
        "settings_section_security": "Sicurezza",
        "settings_pwd_title": "Cambia password",
        "settings_pwd_hint": "Scegli una password sicura (12+ car., maiuscola, numero, simbolo)",
        "settings_pwd_current": "Password attuale",
        "settings_pwd_new": "Nuova password",
        "settings_pwd_confirm": "Conferma nuova password",
        "settings_pwd_submit": "Salva password",
        "settings_pwd_submitting": "Salvataggio…",
        "about_title": "Chi siamo",
        "about_intro": "OpenGlow e una piattaforma francese che semplifica l'incontro tra clienti e professionisti della bellezza.",
        "about_mission_title": "La nostra missione",
        "about_mission_text": "Aiutare ogni persona a trovare rapidamente un professionista affidabile vicino a casa, con un'esperienza di prenotazione semplice, trasparente e moderna.",
        "about_build_title": "Cosa stiamo costruendo",
        "about_build_item_1": "Un'area cliente chiara per cercare, prenotare e seguire gli appuntamenti.",
        "about_build_item_2": "Un'area professionista per gestire agenda, servizi, recensioni e annunci.",
        "about_values_title": "I nostri valori",
        "about_values_simple_label": "Semplicita:",
        "about_values_simple_text": "un'interfaccia rapida da capire per tutti.",
        "about_values_trust_label": "Fiducia:",
        "about_values_trust_text": "informazioni chiare e profili verificati.",
        "about_values_respect_label": "Rispetto:",
        "about_values_respect_text": "protezione dei dati personali e approccio responsabile.",
        "about_values_exigence_label": "Esigenza:",
        "about_values_exigence_text": "miglioramento continuo dell'esperienza utente.",
        "about_contact_title": "Contatto",
        "about_contact_line_1": "Hai una domanda o hai bisogno di aiuto?",
        "about_contact_line_2": "Usa la chat interna del sito per una risposta piu rapida.",
        "about_contact_line_3": "Per qualsiasi altra richiesta, scrivici a",
        "settings_show_pwd": "Mostra",
        "settings_hide_pwd": "Nascondi",
        "passwords_mismatch": "Le password non corrispondono.",
        "password_change_success": "Password modificata con successo.",
        "password_change_error": "Errore durante la modifica della password.",
        "network_error_retry": "Errore di rete. Riprova."
    }
}